import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { Toggle } from 'pepsico-ds';
import { IToggleProps } from 'pepsico-ds/dist/lib/Atoms/Toggle/types';

const Container = styled.div`
  display: inline-block;
  margin-right: 8px;
`;

export type ToggleWrapperProps = Omit<IToggleProps, 'onUpdate' | 'isDark'> & {
  /** Default checked state for the toggle (true/false) */
  defaultChecked?: boolean;
  checked?: boolean;
  /** Callback invoked when the toggle state changes */
  onChange?: (checked: boolean) => void;
};

/**
 * The ToggleWrapper component.
 *
 * It manages the toggle state internally and forwards the appropriate props to the third-party Toggle.
 */
export const ToggleWrapper: FC<ToggleWrapperProps> = ({
  defaultChecked = false,
  onChange,
  disabled = false,
  size = 'medium',
  variant = 'horizontal',
  showCheckedIcon = true,
  ...rest
}) => {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  const handleToggle = (checked: boolean) => {
    setIsChecked(checked);
    onChange?.(checked);
  };

  return (
    <Container>
      <Toggle
        {...rest}
        checked={isChecked}
        disabled={disabled}
        size={size}
        variant={variant}
        showCheckedIcon={showCheckedIcon}
        onUpdate={handleToggle}
      />
    </Container>
  );
};
